export const VSS_EVENTS = {
    // 供货规则切换事件
    VSS_HEADER_SUPPLIER_CHANGE: 'supplierIdChange',
    // 供应商选择器属性
    VSS_HEADER_SUPPLIER_SELECT: 'supplierSelect',
};

export default {
    VSS_EVENTS,
};
